import { render, staticRenderFns } from "./WeekdayQuickSettings.vue?vue&type=template&id=5804c2b7&"
import script from "./WeekdayQuickSettings.vue?vue&type=script&lang=js&"
export * from "./WeekdayQuickSettings.vue?vue&type=script&lang=js&"
import style0 from "./WeekdayQuickSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports